import React from "react";
import {Box, Button, Columns} from "react-bulma-components"
import {readableDate} from "../../../utils";

export default function QuoteItem({quote, onDuplicate}){

    return (
        <Columns>
            <Columns.Column>
                <Box>
                    <Columns>
                        <Columns.Column>
                            <h2 className={"bold"}>Quote - {quote.id} - {quote.department ? quote.department.name : ""}</h2>
                        </Columns.Column>
                        <Columns.Column>
                            <p>Duplicate - {quote.duplicate ? "Yes" : "No"}</p>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <p>Customer 1 - {quote.customer ? quote.customer.display_name : ""}</p>
                        </Columns.Column>
                        <Columns.Column>
                            <p>Customer 2 - {quote.customer2 ? quote.customer2.display_name : ""}</p>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <p>Provisional Start Date - {readableDate(quote.provisional_start_date)}</p>
                        </Columns.Column>
                        <Columns.Column>
                            <p>Description - {quote.description}</p>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Button
                                color={"success"}
                                onClick={() => onDuplicate(quote)}
                            >
                                Duplicate
                            </Button>
                        </Columns.Column>
                    </Columns>
                </Box>
            </Columns.Column>
        </Columns>
    )


}